"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
var BirthStatusOptionalContent_1 = __importDefault(require("./BirthStatusOptionalContent"));
var BirthStatusOptionalText_1 = __importDefault(require("./BirthStatusOptionalText"));
var BirthStatusOptional = /** @class */ (function (_super) {
    __extends(BirthStatusOptional, _super);
    function BirthStatusOptional(props) {
        var _this = _super.call(this, props) || this;
        _this.key = "";
        _this.state = {
            value: "",
            error: []
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            var number = _this.props.number;
            if (_this._isMounted) {
                var state = form_store_1.default.getState();
                _this.setState({
                    value: state.data[_this.key] || "",
                    error: state.error[_this.key] || []
                });
            }
        });
        return _this;
    }
    BirthStatusOptional.prototype.componentDidMount = function () {
        var number = this.props.number;
        this.key = "birth_status_optional_".concat(number);
        this._isMounted = true;
        var state = form_store_1.default.getState();
        this.setState({
            value: state.data[this.key] || "",
            error: state.error[this.key] || []
        });
    };
    BirthStatusOptional.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    BirthStatusOptional.prototype.render = function () {
        var number = this.props.number;
        var keyname = "birth_status_optional_".concat(number);
        var _a = this.state, value = _a.value, error = _a.error;
        var errorElem = (react_1.default.createElement("div", null));
        var params = [
            { name: '胎児心拍異常' },
            { name: '呼吸障害' },
            { name: '感染症' },
            { name: '低酸素脳症' },
            { name: '溶血性疾患' },
            { name: '多胎間輸血症候群' },
            { name: '先天異常' },
            { name: 'その他' }
        ];
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        var fields = params.map(function (param, idx) {
            return (react_1.default.createElement("li", { key: idx, className: "input-list__item" },
                react_1.default.createElement("label", { className: "input-checkbox" },
                    react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: keyname, value: idx + 1, checked: value.indexOf("".concat(idx + 1)) > -1, onChange: input_actions_1.default.changeInput }),
                    react_1.default.createElement("span", { className: "input-checkbox__text" }, param.name))));
        });
        var contentField1 = value.indexOf("7") > -1 ? react_1.default.createElement(BirthStatusOptionalContent_1.default, { label: params[(6)].name, optNum: "7", number: number }) : "";
        var contentField2 = value.indexOf("8") > -1 ? react_1.default.createElement(BirthStatusOptionalText_1.default, { label: params[(7)].name, optNum: "8", number: number }) : "";
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("ul", { className: "input-list input-list--vertical" }, fields),
            contentField1,
            contentField2));
    };
    return BirthStatusOptional;
}(react_1.Component));
exports.default = BirthStatusOptional;
